import React, { Component, useState, createRef } from "react";
import ReactPlayer from "react-player/youtube";
import "../index.scss";
import ActionButton from "./actionButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import BkashLogo from "../icons/bKash_Logo_button.svg";
import BkashIcon from "../icons/bKash_Logo_Icon.svg";

const VideoPlayer = ({ data, isShort = true, callBack, mode }) => {
  const [isReady, setIsReady] = useState(false);

  // Function to handle when video is ready
  const handleReady = () => {
    setIsReady(true);
  };

  // Calculate dimensions for Shorts (9:16 aspect ratio)
  const shortsDimensions = {
    width: "315px",
    height: "560px",
  };

  // Calculate dimensions for regular videos (16:9 aspect ratio)
  const regularDimensions = {
    width: "560px",
    height: "315px",
  };

  const dimensions = isShort ? shortsDimensions : regularDimensions;
  return (
    <div className="video-player-outer-container">
      <div className="action-button-container">
        <ActionButton
          title={mode === "modal" ? "ফেরত যান" : "কুইজ খেলুন"}
          onClick={callBack}
          leftIconSrc={BkashLogo}
        />
      </div>
      {mode !== "modal" && (
        <div className="video-instruction">
          <img src={BkashIcon} />
          <p>{data?.video_screen_instrcutions}</p>{" "}
        </div>
      )}

      <div
        className="video-player-container"
        style={{
          opacity: isReady ? 1 : 1,
          transition: "opacity 0.4s ease-in-out",
        }}
      >
        {!isReady && (
          <div className="loader-container">
            <CircularProgress size={40} style={{ color: "#e2166e" }} />
          </div>
        )}
        <ReactPlayer
          url={data?.video_link}
          width={dimensions.width}
          height={dimensions.height}
          controls={true}
          playing={true}
          onReady={handleReady}
          config={{
            youtube: {
              playerVars: {
                modestbranding: 1,
                rel: 0,
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default VideoPlayer;
